module.exports = __webpack_public_path__ + "static/media/best-hooman.7c170a70.png";